<template>
  <v-container class="quotations-main" id="quotations-container">
    <div class="boxes">
      <div class="maintitle">{{ $t("Quotations.Title") }}</div>
      <v-row class="row-boxes">
        <v-col
          cols="6"
          xs="6"
          class="lg2-custom"
          v-for="(d, index) in divisions"
          :key="index"
          @click="selectDivision(index, true)"
          v-if="index == 0 || index == 3"
        >
          <division :item="d" :style="{ opacity: d.opacity }"> </division>
        </v-col>
      </v-row>
    </div>

    <div id="commercialsAnchor" ref="commercialsAnchor"></div>
    <div>
      <div
        class="boxes second-row"
        v-if="
          commercials_division && commercials_division.commercials.length > 0
        "
      >
        <div class="maintitle">
          {{
            $t("Quotations.CommercialsTitle").replace(
              "{0}",
              divisions[selectedDivision].title
            )
          }}
        </div>
        <v-row>
          <v-col
            cols="12"
            :md="commercials_division.commercials.length == 3 ? 4 : 6"
            v-for="(c, index) in commercials_division.commercials"
            :key="index"
            :class="[
              commercialRequest.item
                ? commercialRequest.item == c
                  ? 'commercial-col show-request-container'
                  : 'commercial-col not-show-request-container'
                : 'commercial-col',
            ]"
          >
            <commercialbox
              :item="c"
              :color="commercials_division.color"
              :component_class="
                getClass(
                  commercials_division.commercials,
                  commercialRequest.item == c
                )
              "
              :showTerm="true"
              :isProfile="false"
              :isInQuotations="true"
              :division="divisions[selectedDivision].title"
              v-on:created="commercialCreated(index)"
              v-on:contact="contactClicked()"
            ></commercialbox>
          </v-col>
        </v-row>
      </div>
    </div>

    <div v-if="!showCommercialRequest">
      <div
        class="boxes second-row"
        v-if="
          commercials_division && commercials_division.commercials.length == 0
        "
      >
        <div class="maintitle">
          {{
            $t("Quotations.NoCommercialsTitle").replace(
              "{0}",
              divisions[selectedDivision].title
            )
          }}
        </div>
        <v-row>
          <v-col cols="12">
            <nocommercialbox
              :color="commercials_division.color"
              :division="divisions[selectedDivision].title"
              v-on:created="commercialCreated(-1)"
            ></nocommercialbox>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>
<style>
.quotations-main .maintitle {
  font: normal normal bold 30px/37px Roboto;
  letter-spacing: 0px;
  color: #5d6367;
}

/* .quotations-main .boxes.second-row .row {
  margin-top: 29px;
} */

.quotations-main .vertical-box .card-body img {
  width: 47px;
}

.quotations-main .vertical-box.two-commercial .inner-card-body div,
.quotations-main .vertical-box.three-commercial .inner-card-body div,
.quotations-main .vertical-box.one-commercial .inner-card-body div {
  padding: 8px 0 8px 0;
}

.quotations-main .vertical-box .card-body span {
  padding-left: 36px;
}

.quotations-main .input-form-container {
  padding-left: 120px;
  margin-top: 20px;
}

.quotations-main .no-commercial-box-container .input-form-container {
  padding-left: 0px;
}

.quotations-main .no-commercial-box-container {
  position: relative;
}

.quotations-main .no-commercial-box-container .email-sent {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
}

.quotations-main .vertical-box.full-commercial .card-header .fullname,
.quotations-main .vertical-box.two-commercial .card-header .fullname,
.quotations-main .vertical-box.three-commercial .card-header .fullname,
.quotations-main .vertical-box.one-commercial .card-header .fullname {
  padding-top: 24px;
  padding-bottom: 8px;
}

.quotations-main .userdata-container {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: unset;
  border-radius: 0px;
  padding: 0;
}

.quotations-main .no-commercial-box-container .company-col.col-sm-3.col-12,
.quotations-main .no-commercial-box-container .first-col.col-sm-4.col-12 {
  flex: 0 0 50%;
  max-width: 50%;
}

.quotations-main .no-commercial-box-container .row {
  margin-left: 0px;
}

@media (max-width: 600px) {
  .quotations-main .maintitle {
    font: normal normal bold 20px/24px Roboto !important;
    color: #5d6367;
    margin: 16px 0 16px 0 !important;
  }

  .quotations-main .commercialrequest-div .maintitle {
    font: normal normal bold 20px/24px Roboto !important;
    color: #5d6367;
    margin: 28px 12px 16px 12px;
  }
  .quotations-main .commercialrequest-row {
    margin: 0;
  }

  .quotations-main .boxes.second-row .row {
    margin-top: 0px;
  }

  .quotations-main .vertical-box .card-body img {
    width: 22px;
  }

  .quotations-main .vertical-box .card-body span {
    padding-left: 22px;
  }

  .quotations-main .vertical-box .card-body .inner-card-body {
    line-height: 36px;
  }

  .quotations-main .vertical-box.fullcommercial .card-body {
    margin-left: 24px;
  }

  .quotations-main .input-form-container {
    padding-left: 0px;
  }

  .quotations-main .no-commercial-box-container .email-sent {
    position: relative;
    top: auto;
    transform: none;
    left: auto;
  }

  .quotations-main .commercial-col {
    padding-bottom: 0;
  }

  .quotations-main .no-commercial-box-container .company-col.col-sm-3.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .quotations-main .no-commercial-box-container .first-col.col-sm-4.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import loading from "../components/loadingComponent.vue";
import division from "../components/division.vue";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import commercialbox from "../components/commercialBox.vue";
import nocommercialbox from "../components/noCommercialBox.vue";
import router from "@/router/index.js";

export default {
  components: {
    loading,
    division,
    commercialbox,
    nocommercialbox,
  },

  data() {
    return {
      divisions: null,
      commercials_division: null,
      commercials: [],
      commercials_d: [],
      commercials_a: [],
      commercials_l: [],
      commercials_t: [],
      commercials_s: [],
      distribution: this.$genericClass.distribution(),
      transport: this.$genericClass.transport(),
      airocean: this.$genericClass.airocean(),
      logistics: this.$genericClass.logistics(),
      specialservices: this.$genericClass.specialservices(),
      selectedDivision: 0,
      isMobile: false,
      commercialRequest: {
        color: "",
        item: [],
      },
    };
  },

  computed: {
    showCommercialRequest: function () {
      let tmp = this.$store.getters.GET_selectedCommercial;

      this.commercialRequest.item =
        this.$store.getters.GET_selectedCommercial.commercialSelected;
      this.commercialRequest.color =
        this.$store.getters.GET_selectedCommercial.color;

      return tmp.show;
    },
  },

  created() {
    this.closeMenu();

    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    // set opacity to 0.5 to avoid flickering when a division is selected
    this.divisions = this.$genericClass.getQuotationsDivisions();
    this.getCommercials()
      .then((res) => {
        this.initDivision();
      })
      .catch((err) => {
        this.initDivision();
      });
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  updated() {
    if (this.isMobile) {
      this.scrollToCommercial();
    }
  },

  mounted() {},

  methods: {
    initDivision() {
      // if landing from division pre select the right one
      const divisionId = this.$route.params.DivisionId;
      //   console.log("quot divisionid", divisionId);
      if (divisionId) {
        this.selectDivision(divisionId - 1, false);
      } else {
        // if no division has been selected opacity must be 1 instead of 0.5
        this.divisions.forEach((element) => {
          element.opacity = 1;
        });
      }
    },
    contactClicked() {
      //   console.log("contact clicked");
      //   this.scrollToCommercial();
    },
    commercialCreated(index) {},
    getClass(commercials, isSelected) {
      if (this.isMobile && isSelected) {
        return "fullcommercial";
      }

      if (commercials.length == 3) {
        return "three-commercial";
      } else if (commercials.length == 2) {
        return "two-commercial";
      } else if (this.isMobile) {
        return "fullcommercial";
      } else return "one-commercial";
    },
    hideCommercialRequest() {
      let arg = {
        commercialSelected: null,
        show: false,
        color: "",
      };
      this.$store.commit("SET_selectedCommercial", arg);
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    selectDivision(division, redirect) {
      //   console.log("select division", division, redirect);
      if (redirect) {
        router
          .push({ name: "quotations", params: { DivisionId: division + 1 } })
          .catch((err) => {
            this.scrollToCommercial();
            this.hideCommercialRequest();
          });
      } else {
        // set opacity on divisions
        for (let index = 0; index < this.divisions.length; index++) {
          if (index != division) {
            this.divisions[index].opacity = 0.5;
          } else {
            this.divisions[index].opacity = 1;
          }
        }

        this.commercials_division = this.commercials[division];
        this.selectedDivision = division;
        this.hideCommercialRequest();
      }
    },
    async getCommercials() {
      let user = this.$GAUserAuth.user;

      let res = await MyFercamApi.GetCommercials(
        user.fCompanyCode,
        user.companyCode
      );

      var commercials = res.data;

      this.commercials_d = commercials.filter(
        (x) => x.divisione == this.distribution
      );
      this.commercials_a = commercials.filter(
        (x) => x.divisione == this.airocean
      );
      this.commercials_l = commercials.filter(
        (x) => x.divisione == this.logistics
      );
      this.commercials_t = commercials.filter(
        (x) => x.divisione == this.transport
      );
      this.commercials_s = commercials.filter(
        (x) => x.divisione == this.specialservices
      );

      this.commercials = [
        {
          division: "d",
          commercials: this.commercials_d,
          color: this.divisions[0].color,
        },
        {
          division: "t",
          commercials: this.commercials_t,
          color: this.divisions[1].color,
        },
        {
          division: "a",
          commercials: this.commercials_a,
          color: this.divisions[2].color,
        },
        {
          division: "l",
          commercials: this.commercials_l,
          color: this.divisions[3].color,
        },
        {
          division: "s",
          commercials: this.commercials_s,
          color: this.divisions[4].color,
        },
      ];

      //   console.log("commercials", this.commercials);
    },
    scrollToCommercial() {
      //   document
      //     .getElementById("commercialsAnchor")
      //     .scrollIntoView({ behavior: "smooth" });
      if (this.isMobile) {
        this.$refs.commercialsAnchor.scrollIntoView({ behavior: "smooth" });
      }
      //   this.$nextTick(() => {
      //     this.$refs.commercialsAnchor.scrollIntoView({ behavior: "smooth" });
      //   });
      //   console.log("real scroll");
      //   setTimeout(function () {
      //     document
      //       .getElementById("commercialsAnchor")
      //       .scrollIntoView({ behavior: "smooth" });
      //   }, 100);
    },
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },
};
</script>